import { Navigate, Outlet } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";

const ProtectedRoute = () => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  return authStatus === "authenticated" ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
